import { PermissionGroupDocument, PermissionGroupQueryVariables } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const usePermissionGroup = (variables: PermissionGroupQueryVariables) => {
  const { data, loading } = useQuery(PermissionGroupDocument, {
    variables,
  })

  return {
    loading,
    permissionGroup: data?.permissions?.permissionGroup,
  }
}
